import React from 'react'

// import { Link } from 'react-router-dom'
// import bgone from '../../../assets/images/background/bg-16.png'
// import bgtwo from '../../../assets/images/background/bg-17.png'
// import bgthree from '../../../assets/images/background/bg-18.png'
// import menuone from '../../../assets/images/resource/menus-1.jpg'
// import menutwo from '../../../assets/images/resource/menus-2.jpg'

function LeftSide() {
    return (

        <>
            <section className="menu-one">
                {/* <div className="right-bg"><img src={bgone} alt="" title="" /></div> */}
                <div className="auto-container">
                    <div className="title-box centered">
                        {/* <div className="subtitle"><span>STARTER MENU</span></div> */}

                        <div className="pattern-image">
                            <img src={require('../../../../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Салати</h2>
                    </div>

                    <div className="row clearfix">
                        {/* <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image"><img src={menuone} alt="" /></div>
                            </div>
                        </div> */}
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">



                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Шопска салата</h5></div><div className="price"><span>7.80 лв</span></div></div>


                                        <div className="text desc">400 г</div>

                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Салата Капрезе</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                        </div>
                                            <div className="price"><span>8.90 лв</span></div>

                                        </div>
                                        <div className="text desc">450 г</div>

                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Гръцка салата</h5></div><div className="price"><span>9.80 лв</span></div></div>

                                        <div className="text desc">450 г</div>

                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Микс салати с прошуто круто кедрови ядки</h5></div><div className="price"><span>11.90 лв</span></div></div>

                                        <div className="text desc">400 г</div>

                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Цезар салата (с пиле и бекон)</h5></div><div className="price"><span>12.80 лв</span></div></div>


                                        <div className="text desc">450 г</div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="menu-one alternate">
                {/* <div className="right-bg"><img src={bgone} alt="" title="" /></div> */}
                <div className="auto-container">
                    <div className="title-box centered">
                        {/* <div className="subtitle"><span>STARTER MENU</span></div> */}

                        <div className="pattern-image">
                            <img src={require('../../../../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Студиени предястия</h2>
                    </div>

                    <div className="row clearfix">
                        {/* <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image"><img src={menuone} alt="" /></div>
                            </div>
                        </div> */}
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">



                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Брускети микс</h5></div><div className="price"><span>13.90 лв</span></div></div>
                                        <div className="text desc">със сьомга, прошуто круто, домат, моцарела, зехтин, босилек и чесън</div>

                                        <div className="text desc">350 г</div>

                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Тартар от сьомга и авокадо</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                        </div>
                                            <div className="price"><span>14.90 лв</span></div>

                                        </div>
                                        <div className="text desc">200 г</div>

                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Плато сирена</h5></div>

                                            <div className="price"><span>16.40 лв</span></div></div>

                                        <div className="text desc">300 г</div>

                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Плато пушени колбаси</h5></div><div className="price"><span>28.90 лв</span></div></div>
                                        <div className="text desc">350 г</div>

                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="menu-one alternate">
                {/* <div className="right-bg"><img src={bgone} alt="" title="" /></div> */}
                <div className="auto-container">
                    <div className="title-box centered">
                        {/* <div className="subtitle"><span>STARTER MENU</span></div> */}

                        <div className="pattern-image">
                            <img src={require('../../../../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Топли предястия</h2>
                    </div>

                    <div className="row clearfix">
                        {/* <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image"><img src={menuone} alt="" /></div>
                            </div>
                        </div> */}
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">



                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Пилешки крилца (в луизиана сос пикантен)</h5></div><div className="price"><span>9.90 лв</span></div></div>


                                        <div className="text desc">500 г</div>

                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Пилешки крилца (в луизиана сос пикантен)</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                        </div>
                                            <div className="price"><span>16.90 лв</span></div>

                                        </div>
                                        <div className="text desc">1000 г </div>

                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Пилешки хапки в корнфлейкс</h5></div><div className="price"><span>9.90 лв</span></div></div>

                                        <div className="text desc">350 г</div>

                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">

                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Камембер на плоча</h5></div><div className="price"><span>8.90 лв</span></div></div>
                                        <div className="text desc">в луизиана сос пикантен</div>
                                        <div className="text desc"> 250 г</div>

                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Тиквички по гръцки</h5></div><div className="price"><span>10.90 лв</span></div></div>

                                        <div className="text desc">с млечен сос</div>
                                        <div className="text desc">300 г</div>


                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="menu-one alternate">
                {/* <div className="right-bg"><img src={bgone} alt="" title="" /></div> */}
                <div className="auto-container">
                    <div className="title-box centered">
                        {/* <div className="subtitle"><span>STARTER MENU</span></div> */}

                        <div className="pattern-image">
                            <img src={require('../../../../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Бургери</h2>
                    </div>

                    <div className="row clearfix">
                        {/* <div className="image-col col-lg-7 col-md-12 col-sm-12">
                            <div className="inner">
                                <div className="image"><img src={menuone} alt="" /></div>
                            </div>
                        </div> */}
                        <div className="menu-col col-lg-5 col-md-12 col-sm-12">
                            <div className="inner">



                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Пилешки бургер</h5></div><div className="price"><span>14.90 лв</span></div></div>

                                        <div className="text desc">със салата домашна коуслоу и сладък пържен картоф</div>
                                        <div className="text desc">450 г</div>
                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Телешки бургер</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                        </div>
                                            <div className="price"><span>17.90 лв</span></div>

                                        </div>

                                        <div className="text desc">със салата домашна коуслоу и сладък пържен картоф</div>
                                        <div className="text desc">550 г</div>


                                    </div>
                                </div>

                                <div className="dish-block">
                                    <div className="inner-box">
                                        <div className="title clearfix"><div className="ttl clearfix"><h5>Телешки бургер</h5>

                                            {/* <span className="s-info">SEASONAL</span> */}

                                        </div>
                                            <div className="price"><span>17.90 лв</span></div>

                                        </div>

                                        <div className="text desc">с чедър и мармалад от червен лук с Пушен бекон</div>
                                        <div className="text desc">550 г</div>


                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>

    )
}

export default LeftSide;